import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useSessionExpiredStore } from "../stores/sessionExpiredStore";
import { queryClient } from "../lib/queryClient";

export function SessionExpiredDialog() {
  const { isOpen } = useSessionExpiredStore();

  const handleSignIn = () => {
    queryClient.clear();
    window.location.href = "/login";
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
              <LogOut className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-white">
              Session expired
            </DialogTitle>
          </div>
        </DialogHeader>

        <DialogDescription className="text-sm text-gray-600 dark:text-gray-400">
          Your session has expired. Please sign in again to continue.
        </DialogDescription>

        <div className="flex justify-end pt-4">
          <Button onClick={handleSignIn} size="sm">
            Sign in again
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
